<template>
  <div class='wrapper'>
    <div class="count-box">
      <div class='count'>{{list.count || 0}}人选择了“{{list.text}}”</div>
      <div>投票时间</div>
    </div>
    <div class="no-user" v-if="list.count==0" />

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="users" :offset='1'>
      <div v-for="(item,i) in list.users" :key="i" class='user-box'>
        <div class='user-item'>
          <img class="user-avatar" :src="item.upic" v-if="item.upic.length>0" />
          <img class="user-avatar" src="../../assets/icon/default_avatar.png" v-else />
          <span>{{item.uname}}</span>
        </div>
        <div class='time'>
          {{item.time}}
        </div>
      </div>
    </van-list>

  </div>

</template>

<script>
import router from '@/router/index'
import http from '@/utils/request';
import api from '@/utils/api'
import { getToken, formatDateTime } from '@/utils/common'
import { constants } from 'fs';
import {Dialog} from "vant";

export default {
  data() {
    return {
      vid: null,
      result: [],
      anonymous: 0,
      list: [],
      loading: false,
      finished: false,
      page: 1,
      count: 40
    }
  },
  mounted() {
    this.vid = this.$route.query.vid;
    this.oid = this.$route.query.oid;
    // this.initData();
  },
  methods: {
    onLoad() {
      this.fetch_items();
    },
    fetch_items() {
      let self = this;
      let parm = {
        vid: this.vid,
        oid: this.oid,
        page: self.page,
        count: self.count,
        access_token: getToken(),
      }
      http.get(api.lotto.getAllList, parm)
        .then((res) => {
          console.log(res.data)
          if (res.sta == 0) {
            self.list.count = res.data.count
            self.list.text = res.data.text
            if (res.data.users.length > 0) {
              res.data.users.map((item, i) => {
                item.time = formatDateTime(item.time * 1000, 2)
              })
              var oldList = self.list.users || [];
              var newList = oldList.concat(res.data.users)
              self.page = self.page * 1 + 1
              // self.result = res.data
              self.list.users = newList
              this.loading = false;
            } else {
              self.finished = true;
              this.loading = false;
            }
          } else {
            self.finished = true;
            this.loading = false;
            Dialog.alert({
              title: '提示',
              message: res.msg || '获取失败'
            })
          }
        })
    }
  }

}

</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.wrapper {
  padding-bottom: rem(60);
}
.count-box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  padding: rem(10) rem(15);
  color: #666;
  font-size: rem(15);
}

.count {
  width: 70.5%;
}

.no-users {
  height: rem(15);
  background: white;
}

.users {
  overflow: hidden;
  background: white;
  padding: rem(10) rem(10) rem(5);
}
.user-item {
  float: left;
  white-space: nowrap;
  padding-bottom: rem(5);
}
.user-avatar {
  float: left;
  width: rem(30);
  height: rem(30);
  border-radius: 50%;
  border: 2px solid #e5e5e5;
}
.user-item span {
  float: left;
  font-size: rem(13);
  margin-left: rem(5);
  line-height: rem(35);
  white-space: nowrap;
  width: rem(138);
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-box {
  display: flex;
  width: 100%;
  display: -webkit-flex;
  justify-content: space-between;
}

.time {
  font-size: rem(13);
  color: #999;
  padding-top: rem(9);
}
</style>



// WEBPACK FOOTER //
// src/pages/all/all.vue